import { render } from "./Upload.vue?vue&type=template&id=b3776728&ts=true"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"

import "./Upload.vue?vue&type=style&index=0&id=b3776728&lang=css"

import exportComponent from "/codebuild/output/src329832614/src/web-ext-giantstep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__